import React from 'react';
import { StyledOptionWrapper, optionStyles } from './SelectPurchaseOptions.style';
import { Box, IconV2, Radio, TextV2 } from '@withjoy/joykit';
import { CheckFilled } from '@withjoy/joykit/icons';
import type { PurchaseOption } from '../../EditGift.controller';

interface OptionProps {
  value: PurchaseOption;
  labelTitle: string | JSX.Element;
  labelDescription: string | JSX.Element;
  checked: boolean;
  onValueChange: (newValue: PurchaseOption) => void;
  name: string;
  id: string;
  disabled?: boolean;
}

export const Option: React.FC<OptionProps> = ({ value, labelTitle, labelDescription, checked, onValueChange, name, id, disabled }) => {
  return (
    <StyledOptionWrapper
      onClick={() => {
        if (disabled) return;
        onValueChange(value);
      }}
      __css={optionStyles(checked, Boolean(disabled))}
    >
      <Box>
        {checked ? (
          <IconV2
            marginRight="0.5rem"
            color={disabled ? 'mono5' : 'purple8'}
          >
            <CheckFilled />
          </IconV2>
        ) : (
          <Radio
            disabled={disabled}
            onChange={() => onValueChange(value)}
            id={id}
            checked={checked}
            tabIndex={0}
            value={value}
            labelHidden={true}
            name={name}
            label=""
          />
        )}
      </Box>
      <Box>
        {typeof labelTitle === 'string' ? <TextV2 typographyVariant="hed1">{labelTitle}</TextV2> : <Box> {labelTitle} </Box>}
        {typeof labelDescription === 'string' ? (
          <TextV2
            typographyVariant="label2"
            color="mono12"
          >
            {labelDescription}
          </TextV2>
        ) : (
          <Box>{labelDescription}</Box>
        )}
      </Box>
    </StyledOptionWrapper>
  );
};
